import { DateTime, Duration } from 'luxon';
/**
 * Indicates if the time is scheduled to occur in less than the given number of hours.
 */
export default function isDateTimeWithinHours(datetimeStr: string, hours: number): boolean {
  const scheduledDate = DateTime.fromISO(datetimeStr);
  const duration = Duration.fromISO(`PT${hours}H`);

  return scheduledDate.diffNow() < duration;
}
